import { Backdrop, Box, CircularProgress, Grid } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AccordianContainer from "../../CustomComponents/AccordianContainer";
import CustomTextField from "../../CustomComponents/CustomTextField";

const LoanDetails = (props) => {
  const [loading, setLoading] = useState(false);
  const filterScreen = useSelector((state) => state.cov.filterScreen);

  const [loanDetailsData, setLoanDetailsData] = useState({
    loanAmount: "",
    sanctionRate: "",
    sanctionTerm: "",
    sanctionEmi: "",
    sanctionDate: "",
    fileStatus: "",
    currentAmount: "",
    balanceTerm: "",
    currentEMI: "",
    dateofMaturity: "",
    currentTerm: "",
    emiNoMonthOS: "",
    emiOS: "",
    interestOS: "",
    totalOS: "",
    dpdDay: "",
    interestFallenDue: "",
    InterestNotDue: "",
    noofDisbursement: "",
    totalDisbursementAmount: "",
    emiPrepayment: "",
    emiReceipt: "",
    principleEMIYTD: "",
    interestEMIYTD: "",
    yearOpeningPrinciple: "",
    closingPrinciple: "",
    ecd: "",
    fbd: "",
    fedd: "",
    billingDay: "",
    loanClosedDate: "",
  });

  useEffect(() => {
    const appNum = localStorage.getItem("appNum");
    getLoanDetailsData(appNum);
  }, []);

  const getLoanDetailsData = async (appNum) => {
    setLoading(true);
    const response = await axios.post("/customerOneView/getLoanDetailData", {
      applicationNum: appNum,
    });
    if (response.status === 200) {
      const data = response.data;
      const setData = {
        loanAmount: parseInt(data.losCustomer.sanctionAmt).toLocaleString(
          "en-IN"
        ),
        sanctionRate: data.losCustomer.rateOfInterest,
        sanctionTerm: data.losCustomer.tenure,
        sanctionEmi:
          data.disbursementRequest !== null
            ? parseInt(
              data.disbursementRequest.sanctionedEmiAmt
            ).toLocaleString("en-IN")
            : "",
        sanctionDate: new Date(
          data.losCustomer.effectiveDate
        ).toLocaleDateString("fr-FR"),
        fileStatus:
          data.disbursementRequest !== null
            ? data.disbursementRequest.requestStatus
            : data.losCustomer.losStatus,
        currentAmount:
          data.nplDemand !== null
            ? parseInt(data.nplDemand.currentLoanAmount).toLocaleString("en-IN")
            : "",
        balanceTerm: data.balanceTenure != -1 ? data.balanceTenure : "",
        currentEMI:
          data.nplDemand !== null
            ? parseInt(data.nplDemand.currentEmi).toLocaleString("en-IN")
            : "",
        dateofMaturity:
          data.dateOfMaturity !== null
            ? new Date(data.dateOfMaturity).toLocaleDateString("fr-FR")
            : "",
        currentTerm:
          data.reSchedulement !== null
            ? data.reSchedulement.revisedTenure
            : data.losCustomer.tenure,
        emiNoMonthOS:
          data.nplDemand !== null ? data.nplDemand.noOfMonthOsEmi : "",
        emiOS:
          data.emiOs !== null
            ? parseInt(data.emiOs).toLocaleString("en-IN")
            : "",
        interestOS:
          data.nplDemand !== null
            ? parseInt(data.nplDemand.interestEmiOs).toLocaleString("en-IN")
            : "",
        totalOS:
          data.totalOs !== null
            ? parseInt(data.totalOs).toLocaleString("en-IN")
            : "",
        dpdDay: data.nplDemand !== null ? data.nplDemand.dpdDays : "",
        interestFallenDue:
          data.nplDemand !== null
            ? parseInt(data.nplDemand.emiInterestDue).toLocaleString("en-IN")
            : "",
        InterestNotDue:
          data.nplDemand !== null
            ? parseInt(data.nplDemand.interestNotDue).toLocaleString("en-IN")
            : "",
        noofDisbursement:
          data.disbursementRequest !== null
            ? data.disbursementRequest.disbNum
            : 0,
        totalDisbursementAmount:
          data.disbursementRequest !== null
            ? parseInt(
              data.disbursementRequest.disbAmt +
              data.disbursementRequest.earlierDisbAmt
            ).toLocaleString("en-IN")
            : 0,
        emiPrepayment:
          data.emiPrepayment !== null
            ? parseInt(data.emiPrepayment).toLocaleString("en-IN")
            : "",
        emiReceipt:
          data.nplDemand !== null
            ? parseInt(data.nplDemand.emiReceipt).toLocaleString("en-IN")
            : "",
        principleEMIYTD:
          data.nplDemand !== null
            ? parseInt(data.nplDemand.emiPrincipal).toLocaleString("en-IN")
            : "",
        interestEMIYTD:
          data.nplDemand !== null
            ? parseInt(data.nplDemand.emiInterest).toLocaleString("en-IN")
            : "",
        yearOpeningPrinciple:
          data.nplDemand !== null
            ? parseInt(data.nplDemand.yearOpeniningPrincipal).toLocaleString(
              "en-IN"
            )
            : "",
        closingPrinciple:
          data.nplDemand !== null
            ? parseInt(data.nplDemand.closingPrincipal).toLocaleString("en-IN")
            : "",
        ecd:
          data.disbursementRequest !== null
            ? data.disbursementRequest.emiCommDate
            : "",
        fbd:
          data.disbursementRequest !== null
            ? data.disbursementRequest.billingDate
            : "",
        fedd:
          data.disbursementRequest !== null
            ? data.disbursementRequest.firstEmiDueDate
            : "",
        billingDay:
          data.disbursementRequest !== null
            ? data.disbursementRequest.billDay
            : "",
        loanClosedDate:
          data.loanclosure !== null
            ? new Date(data.loanclosure.createdDate).toLocaleDateString("fr-FR")
            : "",
      };

      setLoanDetailsData(setData);
      setLoading(false);
    }
  };
  return (
    <>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      )}
      {!loading && (
        <Box>
          <AccordianContainer
            id="accordss"
            initialOpen={true}
            title={"Basic Details"}
            sx={{
              border: "2px solid #1976d2",
            }}
          >
            <Grid container rowSpacing={0} columnSpacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                <CustomTextField
                  type="text"
                  label="Loan Amount (₹)"
                  variant="standard"
                  placeholder=""
                  disabled={true}
                  value={loanDetailsData.loanAmount}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                <CustomTextField
                  type="text"
                  label="Sanction Rate (%)"
                  variant="standard"
                  placeholder=""
                  disabled={true}
                  value={loanDetailsData.sanctionRate}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                <CustomTextField
                  type="text"
                  label="Sanction Term (Months)"
                  variant="standard"
                  placeholder=""
                  disabled={true}
                  value={loanDetailsData.sanctionTerm}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                <CustomTextField
                  type="text"
                  label="Sanction EMI (₹)"
                  variant="standard"
                  placeholder=""
                  disabled={true}
                  value={loanDetailsData.sanctionEmi}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                <CustomTextField
                  type="text"
                  label="Sanction Date"
                  variant="standard"
                  placeholder=""
                  disabled={true}
                  value={loanDetailsData.sanctionDate}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                <CustomTextField
                  type="text"
                  label="File Status"
                  variant="standard"
                  placeholder=""
                  disabled={true}
                  value={loanDetailsData.fileStatus}
                />
              </Grid>
            </Grid>
          </AccordianContainer>
          <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <AccordianContainer
                id="accord"
                title="Current Status"
                initialOpen={true}
                sx={{
                  width: "100%",
                  marginTop: "8px !important",
                  height: "100%",
                  border: "2px solid #1976d2",
                }}
              >
                <Grid container rowSpacing={2} columnSpacing={3}>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="Current Amount (₹)"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.currentAmount}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="Current Term (Months)"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.currentTerm}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    {" "}
                    <CustomTextField
                      type="text"
                      label="Current EMI (₹)"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.currentEMI}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="Date of Maturity"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.dateofMaturity}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="Balance Term(Months)"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.balanceTerm}
                    />
                  </Grid>
                  {loanDetailsData.fileStatus === "Loan Closed" && (
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="Loan Closed Date"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.loanClosedDate}
                      />
                    </Grid>
                  )}
                </Grid>
              </AccordianContainer>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <AccordianContainer
                id="accord"
                title="Outstanding Details"
                initialOpen={true}
                sx={{
                  width: "100%",
                  marginTop: "8px !important",
                  height: "100%",
                  border: "2px solid #1976d2",
                }}
              >
                <Grid container rowSpacing={2} columnSpacing={3}>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="EMI No. of Month OS"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.emiNoMonthOS}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="EMI OS"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.emiOS}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="Total OS"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.totalOS}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="Interest OS"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.interestOS}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="DPD Day"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.dpdDay}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="Interest Fallen Due"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.interestFallenDue}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="Interest Not Due"
                      variant="standard"
                      placeholder=""
                      disabled={true}
                      value={loanDetailsData.InterestNotDue}
                    />
                  </Grid>
                </Grid>
              </AccordianContainer>
            </Grid>
          </Grid>
          <Box sx={{ marginTop: "8px" }}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <AccordianContainer
                  id="accords"
                  title="Disbursement Details"
                  initialOpen={false}
                  sx={{
                    width: "100%",
                    marginTop: "8px !important",
                    height: "100%",
                    border: "2px solid #1976d2",
                  }}
                >
                  <Grid container rowSpacing={2} columnSpacing={3}>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="No. of Disbursement"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.noofDisbursement}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="Total Disbursed Amount (₹)"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.totalDisbursementAmount}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="Sanction Date"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.sanctionDate}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="Loan Amount"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.loanAmount}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="EMI Prepayment"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.emiPrepayment}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="EMI Receipt"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.emiReceipt}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="Principle EMI YTD"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.principleEMIYTD}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="Interest EMI YTD"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.interestEMIYTD}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="Year Opening Principle"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.yearOpeningPrinciple}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="Closing Principle"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.closingPrinciple}
                      />
                    </Grid>
                  </Grid>
                </AccordianContainer>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <AccordianContainer
                  id="accord"
                  title="Due Date"
                  initialOpen={false}
                  sx={{
                    width: "100%",
                    marginTop: "8px !important",
                    height: "100%",
                    border: "2px solid #1976d2",
                  }}
                >
                  <Grid container rowSpacing={2} columnSpacing={3}>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="ECD"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.ecd}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="FEDD"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.fedd}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="FBD"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.fbd}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <CustomTextField
                        type="text"
                        label="Billing Day"
                        variant="standard"
                        placeholder=""
                        disabled={true}
                        value={loanDetailsData.billingDay}
                      />
                    </Grid>
                  </Grid>
                </AccordianContainer>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
};
export default LoanDetails;
